import getTheme from "./getTheme";
export default function fontWeight(weight, theme) {
    return getTheme(theme).fontWeight[weight];
}
//# sourceMappingURL=fontWeight.js.map